/**
 * Copyright © 2026 Adnuntius AS.
 */
import * as _ from 'lodash';

export function transformJsonProperty(prop: string): {transformRequest: (data: any) => any; transformResponse: (data: any) => any} {
  return {
    transformRequest(data: any): any {
      if (!_.has(data, prop)) {
        return data;
      }
      const transformed = _.cloneDeep(data);
      const value = _.get(transformed, prop);
      _.set(transformed, prop, _.isString(value) ? value : JSON.stringify(value));
      return transformed;
    },
    transformResponse(data: any): any {
      if (_.has(data, prop)) {
        try {
          _.set(data, prop, JSON.parse(_.get(data, prop)));
        } catch (err) {
          // The API may already have returned a parsed value.
        }
      }
      return data;
    }
  };
}

export function transformJsonObjectProperty(prop: string): {transformRequest: (data: any) => any; transformResponse: (data: any) => any} {
  function transformObjectValues(object: any, transform: (value: any) => any): any {
    return _.mapValues(object, transform);
  }

  function forProperty(data: any, transform: (value: any) => any): any {
    const path = prop.split('.');
    if (path.length > 1 && _.isArray(_.get(data, path[0]))) {
      _.forEach(_.get(data, path[0]), (item: any) => {
        const value = _.get(item, path.slice(1));
        if (_.isPlainObject(value)) {
          _.set(item, path.slice(1), transformObjectValues(value, transform));
        }
      });
    } else {
      const value = _.get(data, prop);
      if (_.isPlainObject(value)) {
        _.set(data, prop, transformObjectValues(value, transform));
      }
    }
    return data;
  }

  return {
    transformRequest(data: any): any {
      return forProperty(_.cloneDeep(data), (value: any) => _.isObject(value) ? JSON.stringify(value) : value);
    },
    transformResponse(data: any): any {
      return forProperty(data, (value: any) => {
        try {
          return JSON.parse(value);
        } catch (err) {
          return value;
        }
      });
    }
  };
}
